import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { questionnaireService } from '../services/questionnaireService';

export const getProviderCompliance = createAsyncThunk(
  'providerQuestionnaire/getProviderCompliance',
  async (providerId, { rejectWithValue }) => {
    try {
      const response = await questionnaireService.getProviderCompliance(providerId);
      return response?.data || response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const createQuestionnaire = createAsyncThunk(
  'providerQuestionnaire/createQuestionnaire',
  async ({ providerId, questionnaireType }, { rejectWithValue }) => {
    try {
      const response = await questionnaireService.createQuestionnaire(providerId, questionnaireType);
      return response?.data || response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const providerQuestionnaireSlice = createSlice({
  name: 'providerQuestionnaire',
  initialState: {
    compliance: null,
    questionnaire: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProviderCompliance.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProviderCompliance.fulfilled, (state, action) => {
        state.loading = false;
        state.compliance = action.payload;
      })
      .addCase(getProviderCompliance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createQuestionnaire.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createQuestionnaire.fulfilled, (state, action) => {
        state.loading = false;
        state.questionnaire = action.payload;
      })
      .addCase(createQuestionnaire.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = providerQuestionnaireSlice.actions;

export default providerQuestionnaireSlice.reducer;
